module.exports = __webpack_public_path__ + "img/logo.1997f1e7.png";